import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator function that always returns an error object
export function alwaysInvalid(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		return { 'alwaysInvalid': true }; // Return an error object indicating the validation failed
	};
}
